import { SideNavigationLink } from "../../../components/SideNavigation";

export type GoalsPage = "list" | "dashboard" | "alignment" | "employees-without-goals";

export const GOALS_SIDE_NAVIGATION_LINKS = [
	{
		label: "List",
		href: "/company/goals/list",
		key: "list",
	} as SideNavigationLink,
	{
		label: "Overview",
		href: "/company/goals/dashboard",
		key: "dashboard",
		fullPageLoad: true,
	} as SideNavigationLink,
	{
		label: "Alignment",
		href: "/company/goals/alignment",
		key: "alignment",
	} as SideNavigationLink,
	{
		label: "Employees Without Goals",
		href: "/company/goals/employees-without-goals",
		key: "employees-without-goals",
	} as SideNavigationLink,
];
